// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { get as lodashGet } from 'lodash';
import { toast } from 'react-toastify';
import { Form, Formik } from 'formik';

// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import { getColumnWithSlotSize } from '../../../../utils/biddingHelper';
import { useLoader, useUserRole } from '../../../../hooks';
import { RootBiddingService } from '../../../../services/BiddingService/Root/BiddingService';
import bidClasses from '../Bidding.module.css';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import Checkbox from '../../../../components/Inputs/Checkbox/Checkbox';
import { TextArea } from '../../../../components/Inputs/Input';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../services/BiddingService/Admin/BundleBiddingService';

export const Panic = ({ bid, closeModal, getBids, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const bidStatus = lodashGet(bid, 'settlement', []).length ? lodashGet(bid, 'settlement', []) : lodashGet(bid, 'energySettlement', []);

    const length = bidStatus.length;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);

    const [startLoader, stopLoader] = useLoader();
    const [hourData, setHourData] = useState(lodashGet(bid, ['panic', 'hours'], []));

    const getCheckedhours = (value, productName) => {
        if (value) setHourData([...hourData, productName]);
        else setHourData(hourData.filter((e) => e !== productName));
    };

    const handleSubmit = (values) => {
        const payload = {
            hourData,
            ...values,
        };
        if (hourData.length) service.UpdatePanicHours(bid._id, payload, startLoader, handleSubmitSuccess, handleError, stopLoader);
    };

    const handleSubmitSuccess = () => {
        toast.success('Panic Hours Updated Successfully');
        closeModal();
        getBids();
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div>
            <div className={`${bidClasses.InfoModalContainer}`}>
                <div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={'Select Hours'} size={16} />
                    </div>
                    <Formik initialValues={{ note: lodashGet(bid, ['panic', 'note'], '') }} onSubmit={handleSubmit}>
                        {({}) => (
                            <Form>
                                <div className={bidClasses.TableContainer}>
                                    {columns.map((column, colIndex) => (
                                        <table key={colIndex}>
                                            <thead>
                                                <tr>
                                                    <th>Slot</th>
                                                    <th>Hour</th>
                                                    <th>Cost</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {column.map((key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td>
                                                                <Checkbox
                                                                    checked={hourData.includes(lodashGet(bidStatus, [key, 'productName'])) ? true : false}
                                                                    onChange={(e) => getCheckedhours(e, lodashGet(bidStatus, [key, 'productName']))}
                                                                />
                                                            </td>
                                                            <td>{lodashGet(bidStatus, [key, 'productName'], '--')}</td>
                                                            <td>{lodashGet(bidStatus, [key, 'price'], '--')}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    ))}
                                </div>

                                <div className={allDeviceClasses.FieldControl2}>
                                    <label>Reason</label>
                                    <TextArea name={`note`} />
                                </div>

                                <div className={allDeviceClasses.ButtonContainer}>
                                    <div>
                                        <button type="button" className="btn-secondary" onClick={() => closeModal()}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div>
                                        <button type="submit" className="btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};
